import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	starred: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	name: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	key: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	type: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	owner: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	category: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lastIssueUpdate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectUrl: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// delete this when cleaning up isVisualRefreshEnabled FG
	action: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lastIssueUpdateIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectUrlGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	starred: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-head.starred',
		defaultMessage: 'Starred',
		description: 'Assistive label for the Starred sorting button table header',
	},
	name: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-head.name',
		defaultMessage: 'Name',
		description: 'Name table header',
	},
	key: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-head.key',
		defaultMessage: 'Key',
		description: 'Key table header',
	},
	type: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-head.type',
		defaultMessage: 'Type',
		description: 'Type table header',
	},
	owner: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-head.owner',
		defaultMessage: 'Lead',
		description: 'Lead table header',
	},
	category: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-head.category',
		defaultMessage: 'Category',
		description: 'Category table header',
	},
	lastIssueUpdate: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-head.last-issue-update',
		defaultMessage: 'Last issue update',
		description: 'Last issue update table header',
	},
	projectUrl: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-head.project-url',
		defaultMessage: 'Project URL',
		description: 'Project URL table header',
	},
	// delete this when cleaning up isVisualRefreshEnabled FG
	action: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-head.action',
		defaultMessage: 'More actions',
		description: 'Column heading label for More actions column under Projects List Table',
	},
	lastIssueUpdateIssueTermRefresh: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-head.last-issue-update-issue-term-refresh',
		defaultMessage: 'Last work update',
		description: 'Last issue update table header',
	},
	projectUrlGalaxia: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-head.project-url-galaxia',
		defaultMessage: 'Space URL',
		description: 'Project URL table header',
	},
});
